import { Injectable } from "@angular/core";
import { BaseClient } from "../common/client/base.client";
import { SvcClients } from "../common/client/SvcClients";
import { TargetTypes } from "../common/entity/enum/targetTypes.enum";
import { NotificationStatuses } from "../common/component/create-notification/create-notification/create-notification.component";
import { NotificationInstance } from "../common/entity/notification/notification.model";


@Injectable({
  providedIn: 'root',
})
export class NotificationClient extends BaseClient {
  constructor() {
    super();
  }

  getNotificationsMetadata(
    returnAsInstances: boolean,
    message?: string
  ) {
    return this.get(
      SvcClients.AdminSvc,
      `GratNotifications/GetNotificationsMetadataForPublisher?returnAsInstances=${returnAsInstances}`,
      message
    );
  }

  submitNotifications(data: NotificationInstance[], status: NotificationStatuses) {
    return this.post(
      SvcClients.AdminSvc,
      `GratNotifications/SubmitNotifications?status=${status}`,
      data
    );
  }

  publishNotification(notificationId: number, skipUsersInsert: boolean) {
    return this.put(
      SvcClients.AdminSvc,
      `GratNotifications/PublishNotification?notificationId=${notificationId}&skipUsersInsert=${skipUsersInsert}`,
      null,
      null
    );
  }

  getTargetTypeCollection(
    targetType: TargetTypes,
    queryValue: string,
    notificationTypeCode?: string,
    customerCode?: number
  ) {
    return this.get(
      SvcClients.AdminSvc,
      `GratNotifications/GetTargetTypeCollection?targetType=${targetType}&queryValue=${queryValue}`
      + (notificationTypeCode ? `&notificationTypeCode=${notificationTypeCode}` : ``)
      + (customerCode ? `&customerCode=${customerCode}` : ``)
    );
  }


  getTargetRights(){
    return this.get(
      SvcClients.AdminSvc,
      `GratNotifications/GetTargetRights` );
  }

  getUserNotifications(
    notificationId?: number,
    notificationTypeCode?: string,
    notificationStatusCode?: string
  ) {
    return this.get(
      SvcClients.AdminSvc,
      `GratNotifications/GetUserNotifications?notificationId=${notificationId}`
      + (notificationTypeCode ? `&notificationTypeCode=${notificationTypeCode}` : ``)
      + (notificationStatusCode ? `&notificationStatusCode=${notificationStatusCode}` : ``)
    );
  }

  getTicketNotificationConversation(notificationId: number) {
    return this.get(
      SvcClients.AdminSvc,
      `GratNotifications/GetTicketNotificationConversation?notificationId=${notificationId}`
    );
  }

  getNotificationsForUser(
    notificationId?: number,
    notificationTypeCode?: string,
    notificationStatusCode?: string
  ) {
    const params = new URLSearchParams();
    if (notificationId) params.append('notificationId', notificationId.toString());
    if (notificationTypeCode) params.append('notificationTypeCode', notificationTypeCode);
    if (notificationStatusCode) params.append('notificationStatusCode', notificationStatusCode);

    return this.get(
      SvcClients.AdminSvc,
      `GratNotifications/GetNotificationsForUser${params.toString() ? '?' + params.toString() : ''}`
    );
  }

  changeNotificationStatus(notificationId: number, notificationStatusId: number) {
    return this.post(
      SvcClients.AdminSvc,
      `GratNotifications/ChangeNotificationStatus?notificationId=${notificationId}&notificationStatusId=${notificationStatusId}`,
      {}
    );
  }

  patchNotificationReadStatus(readRequest: { FkNotification: number, User: number, Read: boolean }) {
    return this.put(
      SvcClients.AdminSvc,
      'GratNotifications/PatchNotificationReadStatus',
      readRequest,
      null
    );
  }

  patchNotificationDiscardedStatus(discardedRequest: { FkNotification: number, User: number, Discarded: boolean }) {
    return this.put(
      SvcClients.AdminSvc,
      'GratNotifications/PatchNotificationDiscardedStatus',
      discardedRequest,
      null
    );
  }
}
